export const lightButton = {
    color: "#161729",
    borderColor: '#161729',
    borderWidth: 2,
    width: "70px",
    height: "30px",
    fontSize: "12px",
    fontWeight: "700",
    boxShadow: 'none',
    borderRadius: 2,
    justifyContent: 'center',
    marginRight: 3,
    '.MuiOutlinedInput-notchedOutline': { border: 0 }
  }
  
  export const darkButton = {
    color: "#FFFFFF",
    borderColor: '#FFFFFF',
    borderWidth: 2,
    width: "70px",
    height: "30px",
    fontSize: "12px",
    fontWeight: "700",
    boxShadow: 'none',
    borderRadius: 2,
    justifyContent: 'center',
    marginRight: 3,
    '.MuiOutlinedInput-notchedOutline': { border: 0 }
  }